import $ from 'jquery';
import { TextureLoader } from 'three';
import { SCENE_INTERACTION } from '../../../constants/scene';
import { getCookie, setCookie } from '../../engine/helpers/cookie';
import UserAvatarCropper from '../../Users/UserAvatarCropper';

import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import 'air-datepicker/air-datepicker.css';

class UserProfile {

    constructor({ model }) {

        this.model = model;
        this.textureLoaderSilent = new TextureLoader();
        this.isEditProOpened = false;
        this.cropper = null;
        this.selectedFile = null;
        this.avatarCropper = null;

        if (this.model.config.isGuest) {
            //Guest - choose
            $('#uploadAvatar').html($trans('choosen-avatar'));
            $('.dsc').html(`<p>${$trans('please-select-avatar')}</p>`);
            $('#uploadAvatar .icon').hide();
        } else {
            //User - upload
            const myId = parseInt(this.model.config.myUserId, 10);
            const pageUserId = parseInt(this.model.config.userId, 10);
            if (!Number.isNaN(myId) && !Number.isNaN(pageUserId) && myId === pageUserId) {
                // Initialize the avatar upload functionality
                this.initAvatarUpload();
            } else {
                // Not owner: remove edit affordance
                $('.profile-info__avatar-edit').remove();
            }
        }

        $('#create-guest-user input[name=userName]').on("keydown", (e) => {

            if (e.keyCode == 13) {
                e.preventDefault();
                $("#save-profile").trigger("click");
            }

        });

        if (document.getElementById('birthday')) {

            let startDate = new Date();
            if ($('#birthday').val() != '') {

                startDate = new Date($('#birthday').val());
            }
            const picker = new AirDatepicker('#birthday', {
                // dateFormat: 'dd.M.yyyy.',
                startDate: startDate,
                locale: localeEn,
                autoClose: true,
            });
        }


        $("#save-myprofile").on("click", (e) => {
            e.preventDefault();
            // const userId = this.model.config.userId;
            const userId = $('#profile-editing input[name=userId]').val();
            const userName = $('#profile-editing input[name=userName]').val();
            const title = $('#profile-editing input[name=title]').val();
            const company = $('#profile-editing input[name=company]').val();
            const location = $('#profile-editing input[name=location]').val();
            const birthday = $('#profile-editing input[name=birthday]').val();
            const bio = $('#profile-editing input[name=bio]').val();
            const website = $('#profile-editing input[name=website]').val();
            const interests = $('#profile-editing input[name=interests]').val();
            let userAvatarUrl;
            let data = {};

            userAvatarUrl = $('#chosen-avatar').attr('src');
            // this.model.saveProfile({ url: this.model.config.saveProfileUrl, data });
            data = {
                userId,
                userAvatarUrl,
                userName,
                title,
                company,
                location,
                birthday,
                bio,
                website,
                interests
            };
            console.log('User data: ', data);
            this.model.saveProfile({ url: this.model.config.saveProfileUrl, data });


            this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_AVATAR_CHANGED, data });
            this.model.userAvatarTexture = this.textureLoaderSilent.load(data.userAvatarUrl);
            // $('#username').html(userName);
            $(".edit_profile_holder").removeClass("is-active");


        });

        $("#save-profile").on("click", (e) => {
            e.preventDefault();
            const userId = this.model.config.userId;
            const userName = $('#create-guest-user input[name=userName]').val();
            let userAvatarUrl;
            let data = {};
            if (this.model.config.isGuest) {
                userAvatarUrl = $('#create-guest-user input[name=avatarChosen]:checked').val();

                let guestAvatarUrl = getCookie('guestAvatarUrl');
                let guestName = getCookie('guestName');
                if (userName != guestName) {
                    setCookie('guestName', userName, 30);
                }
                if (userAvatarUrl != guestAvatarUrl) {
                    setCookie('guestAvatarUrl', userAvatarUrl, 30);
                }
                console.log('getCookieL ', getCookie('guestName'), getCookie('guestAvatarUrl'));
                setCookie('skipWelcome', true, 30);
                data = {
                    userId,
                    userAvatarUrl,
                    userName
                };
                console.log('Guest data: ', data);
                this.model.config.userAvatarUrl = data.userAvatarUrl;
                //window.location.reload();

            } else {
                //console.log('isGuest: ', this.model.config.isGuest, userId);
                userAvatarUrl = $('#chosen-avatar').attr('src');
                // this.model.saveProfile({ url: this.model.config.saveProfileUrl, data });
                data = {
                    userId,
                    userAvatarUrl,
                    userName
                };
                this.model.config.userAvatarUrl = data.userAvatarUrl;
                console.log('User data: ', data);
                this.model.saveProfile({ url: this.model.config.saveProfileUrl, data });
            }

            this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_AVATAR_CHANGED, data });
            this.model.userAvatarTexture = this.textureLoaderSilent.load(data.userAvatarUrl);
            // $('#username').html(userName);
            $(".edit_profile_holder").removeClass("is-active");


        });

        let avatarCookie = getCookie('guestAvatarUrl');

        let avatarRadios = $('#create-guest-user input[type="radio"]');
        avatarRadios.on('change', (e) => {
            if (e.target.checked) {
                avatarRadios.each(function () {
                    $(this).parent('label').removeClass('chosen');
                });
                $(e.target).parent('label').addClass('chosen');
                $('#chosen-avatar').attr('src', e.target.value);
            }
        });


        $('#editProfile').on('click', (e) => {
            e.preventDefault();
            if (this.model.config.isGuest) {
                $(".guest-welcome-modal-holder").addClass("is-active");
                return;
            }

            $("#save-profile").addClass("disabled");
            $(".join-guest-header").hide();
            $(".edit-profile-header").css('display', 'flex');
            $(".edit_profile_holder #save-profile").text($trans('save-text'));
            $(".edit_profile_holder #save-profile").attr("data-lang", "save-text");

            const { userAvatarUrl, userName } = this.model.getUserData();

            !this.isEditProOpened ? $(".edit_profile_holder").addClass("is-active") : $(".edit_profile_holder").removeClass("is-active");
            if (this.model.config.email !== null) {
                $('.local-avatar').attr('src', userAvatarUrl);
                $('input[name="userName"]').val(userName);
                $('.login-btns').hide();
                $('#skip-welcome').hide();
            } else {
                let guestAvatar = getCookie('guestAvatarUrl');
                let radioAvatar = $('input:radio[name=avatarChosen][value="' + guestAvatar + '"]');
                radioAvatar.attr('checked', true);
                radioAvatar.parent().addClass('chosen');
                $('.local-avatar').attr('src', guestAvatar);
                $('input[name="userName"]').val(getCookie('guestName'));
            }
            if (getCookie('skipWelcome') === 'true') {
                $('#skip-welcome').hide();
            }

        });



        const skipCookie = getCookie('skipWelcome');

        // if(skipCookie && skipCookie != ''){

        //     console.log('skipCookie ',skipCookie);
        // }else{

        //     console.log('No skipCookie ');
        // }

        //First time user
        if (skipCookie !== 'true' && skipCookie != '') {
            // const userProperties = this.model.config;
            const userProperties = this.model.getUserData();

            console.log('userProperties ', userProperties);
            // let avatarCookie = getCookie('guestAvatarUrl');
            if (this.model.config.email === null) {

                $("#create-guest-user input[name='avatarChosen']").each(function () {
                    if ($(this).val() == avatarCookie) {
                        $(this).prop('checked', true);
                        $(this).parent('label').addClass('chosen');
                    }
                });

                $(".welcome_holder").addClass("is-active");
                $('.local-avatar').attr('src', userProperties.userAvatarUrl);
                $('input[name="userName"]').val(userProperties.userName);
            }
        }

        $("#skip-welcome").on("click", (e) => {
            console.log('skip-welcome');
            $(".edit_profile_holder .modal-card-title").text($trans('my-profile-text'));
            $(".edit_profile_holder").removeClass("is-active");
            setCookie('skipWelcome', 'true', 30);
        });


        $('#create-guest-user input[name="userName"]').on("change", () => {
            $("#save-profile").removeClass("disabled");
        });

        $("#joinAsGuest").on("click", (e) => {
            $(".edit_profile_holder").addClass("is-active");
            $(".welcome_holder").removeClass("is-active");
            $(".join-guest-header").show();
            $(".edit-profile-header").hide();
            $(".edit_profile_holder #save-profile").text($trans('access-room-text'));
            $(".edit_profile_holder #save-profile").attr("data-lang", "access-room-text");
            //join-guest-header
            // $(".edit_profile_holder .modal-card-title").text("Edit Profile");
            // $(".edit_profile_holder").removeClass("is-active");
            // setCookie('skipWelcome', 'true', 30);
        });

        $(".btn-enter-room").on("click", (e) => {
            $(".edit_profile_holder").removeClass("is-active");
        });

        $(".login-back").on("click", (e) => {
            $(".edit_profile_holder").removeClass("is-active");
            $(".welcome_holder").addClass("is-active");
        });

        this.model.addEventListener(SCENE_INTERACTION.USER_AVATAR_CHANGED, (e) => {
            const { data } = e;
            Object.keys(data).forEach((key) => {
                switch (key) {
                    case 'userAvatarUrl':
                        this.model.config.userAvatarUrl = data.userAvatarUrl;
                        this.model.userAvatarTexture = this.textureLoaderSilent.load(data.userAvatarUrl);
                        break;
                    case 'userName':
                        this.model.config.userName = data.userName;
                        $(`[data-user-field="username"]`).text(data[key] || '　');
                        break;
                    default:
                        $(`[data-user-field="${key}"]`).text(data[key] || '　');
                        break;
                }
            });
        });
    }

    /**
     * Initialize avatar upload modal and functionality
     */
    initAvatarUpload() {
        // Initialize the avatar cropper component
        this.avatarCropper = new UserAvatarCropper({
            api: {
                temporaryFileUploadUrl: this.model.config.temporaryFileUploadUrl,
                addImageUrl: this.model.config.addImageUrl
            },
            baseWebUrl: this.model.config.baseWebUrl,
            onSuccess: (url) => {
                const data = {
                    userId: this.model.config.userId,
                    userAvatarUrl: url,
                    userName: this.model.config.userName
                };
                this.model.saveProfile({
                    url: this.model.config.saveProfileUrl,
                    data,
                }, () => {

                    $('.local-avatar, .user-avatar img').attr('src', url);

                    // Update 3D scene avatar
                    this.model.dispatchEvent({
                        type: SCENE_INTERACTION.USER_AVATAR_CHANGED,
                        data: { userAvatarUrl: url }
                    });

                    this.model.config.userAvatarUrl = data.userAvatarUrl;
                    this.model.userAvatarTexture = this.textureLoaderSilent.load(url);
                });
            }
        }, this.model);

        // Initialize the component
        this.avatarCropper.init();

        // Open upload modal when avatar is clicked
        const myId = parseInt(this.model.config.myUserId, 10);
        const pageUserId = parseInt(this.model.config.userId, 10);
        if (!Number.isNaN(myId) && !Number.isNaN(pageUserId) && myId === pageUserId) {
            $('.profile-info__avatar, .profile-info__avatar-edit').on('click', () => {
                this.avatarCropper.showUploadModal();
            });
        }
    }
}

export default UserProfile;
